module.exports = __webpack_public_path__ + "assets/img/a6261dc513b6e449736c49bba0b6ac71.png";